import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import BarCodeField from './BarCodeField';
import FormInput from '../../common/components/FormInput';
import FormMultiline from '../../common/components/FormMultiline';
import PLUField from './PLUField';

const LabelCol2Form = ({
  activePLU,
  detailFields,
  handleSubmit,
  logoUrl,
  onCancel,
  petLabel,
  submitButtonText
}) => { 
  const fields = detailFields.map((detailField, index) => {
    const keyName = `Key${index}`;
    const valueName = `Value${index}`;
    return (
      <tr key={index}>
        <td className="category">
          <Field name={keyName}
                 component={FormInput}
                 type="text"
                 className="form-control"
          />
        </td>
        <td className="info">
          <Field name={valueName}
                 component={FormInput}
                 type="text"
                 className="form-control"
          />
        </td>
      </tr>
    );
  });

  return (
    <div className="row">
      <div className="col-lg-12">
        <form onSubmit={handleSubmit}>
          <div className="label-main">
            <div className="label-title">
              <Field name="line1" 
                     component={FormInput} 
                     type="text" 
                     className="form-control"
                     placeholder={I18n.t('ENTER_NAME')}  
              />
              <Field name="line2" 
                     component={FormInput} 
                     type="text" 
                     className="form-control latin-name"
                     placeholder={I18n.t('ENTER_LATIN_NAME')}
              />
            </div>
            <div className="label-content">
              <img src={petLabel.ImageUrl} className="float-left" />
              <table className="float-left" cellPadding="0" cellSpacing="0">
                <tbody>
                  {fields}
                  {activePLU && <PLUField />}
                </tbody>
              </table>
            </div>
            <div className="label-footer">
              <Field name="price" 
                     component={FormMultiline} 
                     type="text" 
                     rows="2"
                     className="form-control float-left txt-price"
                     placeholder={I18n.t('ENTER_PRICE')}
              />
              <div className="label-logo">
                <img src={logoUrl}/>
              </div>
              <BarCodeField />
            </div>    
          </div>
          <div className="row no-gutters bottom-buttons">
            <div className="col-sm-12 text-right">
              {onCancel !== undefined && <button type="button" className="btn btn-secondary" onClick={onCancel}>{I18n.t('CANCEL')}</button>}
              <button type="submit" className="btn btn-primary">{submitButtonText}</button> 
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

LabelCol2Form.propTypes = {
  activePLU: PropTypes.bool.isRequired,
  detailFields: PropTypes.array.isRequired,
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  logoUrl: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  petLabel: PropTypes.object.isRequired,
  submitButtonText: PropTypes.string.isRequired
};

export default reduxForm()(LabelCol2Form);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelCol2Form.js
 **/